import Icon from "@mui/material/Icon"
import { alpha } from "@mui/material/styles"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import colors from "assets/theme/base/colors"

// Compact KPI tile: soft-tint icon chip (reuses the existing palette tokens,
// just tinted) + uppercase label + bold value + optional one-line context —
// only rendered when the report already provides that context.
const ReportKpiCard = ({ label, value, subtext, icon, color = "info" }) => {
  const tint = colors[color]?.main || colors.info.main
  return (
    <MDBox
      bgColor="white"
      borderRadius="xl"
      p={2.25}
      height="100%"
      sx={{ border: "1px solid", borderColor: "grey.200" }}
    >
      <MDBox display="flex" alignItems="flex-start" gap={1.5}>
        {icon && (
          <MDBox
            width="2.25rem"
            height="2.25rem"
            minWidth="2.25rem"
            borderRadius="lg"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ bgcolor: alpha(tint, 0.12), color: tint }}
          >
            <Icon fontSize="small">{icon}</Icon>
          </MDBox>
        )}
        <MDBox sx={{ minWidth: 0 }}>
          <MDTypography
            variant="caption"
            color="text"
            fontWeight="medium"
            textTransform="uppercase"
            sx={{ letterSpacing: "0.04em" }}
          >
            {label}
          </MDTypography>
          <MDTypography variant="h5" fontWeight="bold" sx={{ mt: 0.25, lineHeight: 1.2 }}>
            {value}
          </MDTypography>
          {subtext && (
            <MDTypography
              variant="caption"
              color="text"
              sx={{ display: "block", mt: 0.25, lineHeight: 1.3 }}
            >
              {subtext}
            </MDTypography>
          )}
        </MDBox>
      </MDBox>
    </MDBox>
  )
}

export default ReportKpiCard
